<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <el-button
          type="info"
          @click="dialogVisibleSongKa=true"
        >赠送骑行卡</el-button>
      </div>
    </div>

    <el-table
      :data="riding_card_user_bags"
      resource="riding_card_user_bags"
    >
      <!-- <el-table-column
        prop="user_truename"
        label="用户姓名"
        align="center"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.users.nickname }}({{ scope.row.user_truename }})
        </template>
      </el-table-column> -->
      <el-table-column
        prop="user_mobile"
        label="用户手机号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="take_effect_time"
        label="生效时间"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="is_limit_times"
        label="是否限次"
        align="center"
        show-overflow-tooltip
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_limit_times"
            type="info"
          >限次</el-tag>
          <el-tag
            v-else
            type="success"
          >不限次</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="deduction_money"
        label="单次最多可抵扣（元）"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
      <el-table-column
        prop="expiration_time"
        label="过期时间"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="can_ridding_times"
        label="剩余次数"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
      <el-table-column
        label="状态"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status"
            type="success"
          >有效</el-tag>
          <el-tag
            v-else
            type="danger"
          >失效</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        show-overflow-tooltip
        width="250"
      >
        <template #default="{ row, $index }">
          <el-button
            @click="DetailClick(row)"
            type="success"
          >详情</el-button>
          <el-button
            @click="rowClick(row)"
            type="warning"
          >使用记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
    <!-- 弹框详情信息 -->
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="20%"
    >
      <div class="info-wrp">
        <div class="title">骑行卡详情</div>
        <div class="info-item">
          <span>是否有效:</span>
          <span v-if="row.status == 1">有效</span>
          <span v-else> 无效 </span>
        </div>
        <div class="info-item">
          <span>生效时间:</span>
          <span>{{ row.take_effect_time }}</span>
        </div>
        <div class="info-item">
          <span>是否限次:</span>
          <span v-if="row.is_limit_times == 1">限次</span>
          <span v-else> 不限次 </span>
        </div>
        <div
          class="info-item"
          v-if="row.is_limit_times == 1"
        >
          <span>限次剩余次数:</span>
          <span>{{ row.can_ridding_times }}（次）</span>
        </div>
        <div class="info-item">
          <span>到期时间:</span>
          <span>{{ row.expiration_time }}</span>
        </div>
        <div class="info-item">
          <span>剩余天数:</span>
          <span>{{ row.surplus_days }}</span>
        </div>
      </div>
      <div class="infodiv">
        <div class="title">订单详情</div>
        <div class="info-item">
          <span>订单编号:</span>
          <span>{{ row_order.no }}</span>
        </div>
        <div class="info-item">
          <span>用户姓名:</span>
          <span>{{ row.user_truename }}</span>
        </div>
        <div class="info-item">
          <span>用户手机号:</span>
          <span>{{ row.user_mobile }}</span>
        </div>
        <div class="info-item">
          <span>支付时间:</span>

          <span>{{ row_order.pay_time }}</span>
        </div>
        <div class="info-item">
          <span>支付状态:</span>
          <span v-if="row_order.status">成功</span>
          <span v-else>失败</span>
        </div>
        <div class="info-item">
          <span>支付金额:</span>
          <span style="width:60%;">{{ row_order.pay_money }}</span>
        </div>
      </div>
    </el-dialog>
    <!-- 弹框详情信息end -->

    <!-- 使用记录 -->
    <el-dialog
      title="使用记录"
      :visible.sync="dialogTableVisible"
      width="30%"
    >
      <el-table
        :data="usedLogs"
        :border="false"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          prop="order_no"
          label="订单编号"
          show-overflow-tooltip
          align="center"
          width="240"
        />
        <el-table-column
          prop="deduction_money"
          label="抵扣金额"
          width="80"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag>{{ scope.row.deduction_money }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="created_at"
          label="使用时间"
          width="180px"
          align="right"
        />
      </el-table>
      <div class="card-footer">
        <pagination
          :page="pagess"
          @current-change="walletcurrentpage"
          @size-change="walletpagesize"
          :auto-push="false"
        />
      </div>
    </el-dialog>
    <!-- 使用记录end -->
    <!-- 送卡 -->
    <el-dialog
      title="送卡"
      :visible.sync="dialogVisibleSongKa"
      width="30%"
    >
      <!-- <span>这是一段信息</span>
      -->

      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item
          prop="card_id"
          required
          label="骑行卡"
        >
          <el-select
            class="limit-width"
            v-model="form.card_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in cards"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="用户手机号"
          required
          prop="mobile"
        >
          <el-input
            @keyup.enter.native="searchUser"
            v-model="form.mobile"
          />
        </el-form-item>
        <el-form-item
          label="用户名（真名）"
          v-show="is_show_user"
        >
          <span>{{ nickname }}({{ truename }})</span>
        </el-form-item>
        <el-form-item
          label="头像"
          v-show="is_show_user"
        >
          <img
            :src="avatar"
            min-width="30"
            height="30"
          >
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisibleSongKa = false">取 消</el-button>
        <el-button
          type="primary"
          @click="songka"
        >确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import ButtonLink from "@c/ButtonLink";
import Pagination from "@c/Pagination";
import {
  getRidingCardUserBags,
  getRidingCardUserBagCardLogs
} from "@/api/card-riding-user-bags";
import { giveCardToUser, getRidingCard } from "@/api/card-riding";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getUserByMobile } from "@/api/users";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";

export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      search: [
        // {
        //   type: 'el-select',
        //   field: 'area_id',
        //   label: '骑行区域',
        //   options: [
        //     {
        //       id: '',
        //       name: '全部',
        //     },
        //   ],
        // },
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          type: "el-select",
          field: "status",
          label: "是否有效",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "有效"
            },
            {
              id: 0,
              name: "无效"
            }
          ]
        }
      ],
      riding_card_user_bags: [],
      row: {},
      row_order: {},
      dialogVisible: false,
      page: null,
      dialogTableVisible: false,
      usedLogs: [],
      pagess: null,
      row_id: "",
      first_blood: true,
      dialogVisibleSongKa: false,
      is_show_user: false,
      cards: [],
      form: {
        mobile: "",
        card_id: ""
      },
      truename: "",
      nickname: "",
      avatar: "",
      rules: {
        card_id: [
          { required: true, message: "请选择赠送得骑行卡", trigger: "change" }
        ],
        mobile: [{ validator: checkPhone, trigger: "blur" }]
      }
    };
  },
  inject: ["reload"],
  methods: {
    DetailClick(row) {
      this.row = row;
      this.row_order = row.cardRidingOrder;
      this.dialogVisible = true;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    async walletcurrentpage(i) {
      this.pagess.current_page = i;
      const {
        data: { data, meta }
      } = await getRidingCardUserBagCardLogs({
        card_id: this.row_id,
        page: this.pagess.current_page,
        per_page: this.pagess.page_size
      });
      this.usedLogs = data;
      this.pagess = meta;
    },
    async walletpagesize(i) {
      this.pagess.page_size = i;
      const {
        data: { data, meta }
      } = await getRidingCardUserBagCardLogs({
        card_id: this.row_id,
        page: this.pagess.current_page,
        per_page: this.pagess.page_size
      });
      this.usedLogs = data;
      this.pagess = meta;
    },
    async rowClick(row) {
      this.row_id = row.id;
      const {
        data: { data, meta }
      } = await getRidingCardUserBagCardLogs({ card_id: row.id });
      this.usedLogs = data;
      this.pagess = meta;
      this.dialogTableVisible = true;
    },
    songka() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          giveCardToUser(this.form).then(res => {
            res.then(data => {
              if (data) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.reload();
              }
            });
          });
        } else {
          alert("请检查输入内容");
          return false;
        }
      });
    },
    async searchUser() {
      // console.log(this.form.mobile)
      const [{ data: user }] = await Promise.all([
        getUserByMobile({ mobile: this.form.mobile })
      ]);
      this.truename = user.truename;
      this.nickname = user.nickname;
      this.avatar = user.avatar;
      this.is_show_user = true;
      // console.log(user)
    }
  },
  async created() {
    const [{ data: cards }] = await Promise.all([
      getRidingCard({ all: 1, is_give: 1 })
    ]);

    this.cards = cards;
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[2].options.push.apply(
          this.search[2].options,
          merchant.data
        );
      }
    } 
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(57, newVal);
        const {
          data: { data, meta }
        } = await getRidingCardUserBags(newVal.query);
        this.riding_card_user_bags = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss">
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
.info-wrp .title {
  font-size: 16px;
  // margin: 20px 0 10px;
  padding-top: 10px;
  border-top: 1px solid #ccc;
}
.info-wrp .info-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}
.info-wrp .info-item > span:first-child {
  display: inline-block;
  margin-right: 8px;
  width: 120px;
  text-align: right;
}
.info-wrp .pic-wrp > div:first-child {
  width: 120px;
  text-align: right;
}
.infodiv {
  line-height: 1.15;
  // border-top: 1px solid #ccc;
  padding-bottom: 10px;
  .title {
    border-top: 1px solid #ccc;
    font-size: 16px;
    margin: 10px;
    padding-top: 10px;
  }
  .info-item {
    margin-left: 30px;
    margin-bottom: 10px;
    :first-child {
      display: inline-block;
      width: 85px;
      text-align: right;
      font-size: 14px;
      margin-right: 8px;
    }
  }
}
.success-row {
  background: #0d9e2c;
}
.border-class {
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
</style>
